import React from "react";
import ReactTelephoneInput from "react-telephone-input";
import { allCountries } from "country-telephone-data";
import { testSafeAsset } from "tests/support/assetHelpers";
import config from "shared/config";
import FsInput from "./FsInput";
import TelephoneInputFlagsImage from "./react-telephone-input-flags.png";

const assetFlagsImage = testSafeAsset(TelephoneInputFlagsImage);

export default class FsPhone extends FsInput {
  update(newPhone, newCountry) {
    this.props.formState.updateFormAttribute(
      this.props.attribute,
      newPhone === "+" ? "" : newPhone.replace(/[^0-9+]/g, ""),
    );

    if (this.props.countryAttribute) {
      this.props.formState.updateFormAttribute(
        this.props.countryAttribute,
        newCountry.iso2,
      );
    }
  }

  renderInput() {
    const { formState, attribute, name, disabled, defaultCountry } = this.props;

    return (
      <ReactTelephoneInput
        name={name || attribute}
        className="formControl"
        inputProps={{ id: this.getControlId() }}
        onlyCountries={allCountries.filter(e =>
          config.supportedCountries.includes(e.iso2),
        )}
        defaultCountry={defaultCountry || this.constructor.defaultCountry}
        flagsImagePath={assetFlagsImage}
        value={formState.readFormAttribute(attribute)}
        disabled={disabled}
        onChange={this.update.bind(this)}
        onBlur={this.update.bind(this)}
      />
    );
  }
}

FsPhone.defaultCountry = "de";
